import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
// import { ExpanderPanel } from './ExpanderPanel';
// import { ExpanderPanelGroup } from './ExpanderPanelGroup';
// import HtmlContent from './Html';
// import { Spacer } from './Spacer';
import { AccordionFragment } from '../types/graphqlTypes';
import { Spacer } from '../spacer';
import { Typography } from '../typography';
import ExpanderPanel from '../expanderPanel/ExpanderPanel';
import HtmlContent from '../htmlContent/HtmlContent';
// import { Typography } from './Typography';

export const Accordion: FC<Omit<AccordionFragment, '__typename'>> = ({
  // accordionListing,
  title,
  lead,
  content,
  items,
  ...rest
}) => {
  const accordionListing = items;

  if (accordionListing?.length < 1) {
    return <></>;
  }

  // Schema FAQ Accordion
  const accordionListingFaqs = items;
  const faqSchema = {
    '@context': 'http://schema.org',
    '@type': 'FAQPage',
    mainEntity: accordionListing.map(
      ({ title: accordionTitle, content: accordionContent }) => ({
        '@type': 'Question',
        name: accordionTitle,
        acceptedAnswer: {
          '@type': 'Answer',
          text: accordionContent,
        },
      })
    ),
  };

  return (
    <>
      <Spacer>
        {title || lead || content ? (
          <Spacer spacing="half">
            {title && (
              <Typography component="h3" variant="titleLarge">
                {title}
              </Typography>
            )}
            {lead && (
              <Typography component="p" variant="lead">
                {lead}
              </Typography>
            )}
            {content && <HtmlContent>{content}</HtmlContent>}
          </Spacer>
        ) : (
          ''
        )}
        <Spacer as="ul" spacing="small">
          {accordionListing.map((item, index) => (
            <ExpanderPanel
              key={index}
              title={item.title}
              as="li"
              components={<HtmlContent>{item.content}</HtmlContent>}
            />
          ))}
        </Spacer>
      </Spacer>

      {accordionListingFaqs ? (
        <Helmet encodeSpecialCharacters={false}>
          <script type="application/ld+json">
            {JSON.stringify(faqSchema)}
          </script>
        </Helmet>
      ) : (
        ''
      )}
    </>
  );
};
